import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAccess } from '../../../hooks/useAccess';
import { Paths } from '../../../shared/paths';
import { UsageAnalytics } from './UsageAnalytics';

export default function Analytics() {
  const { access } = useAccess();
  const canViewAnalytics = access?.analytics?.canView ?? false;

  if (!canViewAnalytics) {
    return <Navigate to={Paths.root} replace />;
  }

  return <UsageAnalytics />;
}
